<template>
    <div>
      <v-container>
        <HandleCreateNewFYAdditionalDataGrp
        :dialog="showAdditionalDataGrpDialog"
        :response="aditionalDataResultObj"
        :programName="programName"
        @openCloseDialog="openCloseDialog"
        />
        <v-dialog
        v-model="isDialog"
        persistent
        max-width="60vw">
        <v-overlay :value="overlay">
          <v-progress-circular
            indeterminate
            size="64"
          ></v-progress-circular>
        </v-overlay>
          <v-card
         >
          <v-card-title>
            <span ></span>
          </v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-container>
                <v-row
                  align="center">
                  <v-col cols="3">
                    <v-text-field
                      v-model.number="nextFiscalYear"
                      label="Fiscal Year"
                      type="number"
                      @keydown="onFyChange"
                      @change="onFyChange"
                      @blur="onFyChange"
                    ></v-text-field>
                  </v-col>
                   <v-col cols="4">
                <v-text-field
                    v-model="registerDate"
                    :label="`Register Date`"
                    readonly
                    />
              </v-col>
                  <v-col cols="4">
                    <MultiItemSelect
                      label="Department"
                      item-text="description"
                      item-value="id"
                      :items="departments"
                      :item-list="departmentList"
                      dense
                      single-line
                      @selected-items="selectedDepartments"
                    ></MultiItemSelect>
                  </v-col>
                   <v-col cols="4">
                <v-text-field class="createNew type"
                  id="odCreateNewTypeText"
                  v-model="type"
                  type="text"
                  :rules="reqdSelectValidation"
                  label="Type"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols='3'>
                <v-text-field class="createNew status"
                  id="odCreateNewStatusText"
                  v-model="status"
                  type="text"
                  :rules="reqdSelectValidation"
                  label="Status"
                  readonly
                ></v-text-field>
              </v-col>
                </v-row>
              </v-container>
            </v-form>
            <v-btn
              color="blue darken-1"
              text
              @click="performAction"
            >
              Create
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="close"
            >
              Cancel
            </v-btn>
          </v-card-text>
        </v-card>
        </v-dialog>
      </v-container>
    </div>
  </template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import MultiItemSelect from '@/components/common/base/MultiItemSelect.vue';
import { isEmptyObject } from '../../util/shared/vue-global';
import HandleCreateNewFYAdditionalDataGrp from '../common/createNewFiscalYear/HandleCreateNewFYAdditionalDataGrp.vue';
import { fetchDepartmentUptoFy } from './odTransaction.util';

export default {
  name: 'OdCreateFiscalYearOd',
  components: {
    MultiItemSelect,
    HandleCreateNewFYAdditionalDataGrp,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    programDetails: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    odBaseCrudKey: 'odtransactions',
    type: 'Beginning Balance',
    status: 'Outstanding',
    currentFiscalYear: undefined,
    nextFiscalYear: undefined,
    registerDate: '',
    overlay: false,
    program: 'odTransactions',
    departments: [],
    selectedDepartmentList: [],
    programName: '',
    showAdditionalDataGrpDialog: false,
    aditionalDataResultObj: {},
  }),
  created() {
    this.initializeDialogBox();
  },
  computed: {
    ...mapState({
      odStatsFY: (state) => state.OD.odStatsFY || [],
      departmentsFromStore: (state) => state.OD.departments,
    }),
    ...mapGetters('base/crud', [
      'criteria',
      'items',
    ]),
    ...mapGetters(['todaysDate']),
    isDialog: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit('dialogVal', value);
      },
    },
    fiscalYearList() {
      const registerdYears = (this.odStatsFY || {});
      return registerdYears;
    },
    departmentList() {
      const deptResult = fetchDepartmentUptoFy(this.departmentsFromStore, this.currentFiscalYear);
      return deptResult;
    },
    reqdSelectValidation() {
      return [
        (value) => !!value || 'Required',
      ];
    },
  },
  methods: {
    ...mapActions('OD', [
      'loadFiscalYears',
      'loadDepartments',
    ]),
    ...mapActions('createNewFiscalYearManager', ['createNewFiscalYear']),
    onFyChange() {
      this.currentFiscalYear = this.nextFiscalYear - 1;
      this.registerDate = `${this.currentFiscalYear}-07-01`;
      this.fetchDepartments(this.nextFiscalYear);
    },
    initializeDialogBox() {
      this.loadFiscalYears({ baseCrudKey: this.odBaseCrudKey }).then(() => {
        const regYears = this.fiscalYearList || [];
        if ((regYears || []).length > 0) {
          this.currentFiscalYear = (regYears[regYears.length - 1] || {}).year;
          this.nextFiscalYear = this.currentFiscalYear + 1;
          this.registerDate = `${this.currentFiscalYear}-07-01`;
          this.fetchDepartments(this.nextFiscalYear);
        }
      }).catch((e) => {
        console.warn(e);
      });
    },
    async handleCreateNewFiscalYearResult(resultObj) {
      if (!isEmptyObject(resultObj)) {
        if ((resultObj.componentStatusArr || []).length > 0) {
          this.showAdditionalDataGrpDialog = true;
          this.aditionalDataResultObj = resultObj;
          this.programName = resultObj.programName;
        }
      }
    },
    async performAction() {
      this.onFyChange();
      if (window.confirm(`You are about to create beginning balance records for FY ${this.nextFiscalYear}, on current balances for the FY ${this.currentFiscalYear}.`)) ;

      this.overlay = true;
      await this.odCreateNewFiscalYear();
      this.overlay = false;
      this.close();
    },
    loadDepartmentData() {
      this.departments = this.mapCollectionVal(this.departmentList, 'id');
      return this.departments;
    },
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    selectedDepartments(val) {
      this.departments = val;
    },
    async odCreateNewFiscalYear() {
      this.selectedDepartmentList = (this.departmentList || [])
        .filter((d) => (this.departments || []).includes(d.id));
      const result = await this.createNewFiscalYear({
        programName: this.program,
        nextFiscalYear: this.nextFiscalYear,
        currentFiscalYear: this.currentFiscalYear,
        params: {
          departmentList: this.selectedDepartmentList,
        },
      });
      await this.initializeDialogBox();
      return result;
    },
    close() {
      this.isDialog = false;
    },
    openCloseDialog(value) {
      this.showAdditionalDataGrpDialog = value;
    },
    async fetchDepartments(fiscalYear) {
      const inputFiscalYear = fiscalYear - 1;
      await this.loadDepartments({
        fiscalYear: inputFiscalYear,
      });
      this.loadDepartmentData();
    },
  },
};
</script>
